import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import crossIcon from "../images/cross.png";
import "../css/Common.css";
import { getStorage } from "../Utils/common";

const RepayThankyou = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { txnStatus, txnId } = location.state || {};
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const isTransactionSuccessful = txnStatus === 'SUCCESS' || txnStatus === 'success';

  const buttonStyle = isTransactionSuccessful 
    ? { backgroundColor: '#4FA0FF' }
    : { backgroundColor: '#FF6B6B' };

  useEffect(() => {
    const token = getStorage("token");
    if (token) {
      setIsLoggedIn(true);
    }
  }, []);

  const handleButtonClick = () => {
    if (isLoggedIn) {
      navigate("/my-dashboard");
    } else {
      navigate("/");
    }
  };

  return (
    <div className="thank-you-container">
      <div className="thank-you-content">
        <div 
          className="icon" 
          style={{ 
            width: '80px', 
            height: '80px', 
            margin: '0 auto 20px', 
            backgroundColor: isTransactionSuccessful ? '#4FA0FF' : '#FF6B6B',
            borderRadius: '50%', 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center' 
          }}
        >
          {isTransactionSuccessful ? (
            <img 
              src="https://img.icons8.com/ios-filled/100/ffffff/checked--v1.png" 
              alt="Success Icon" 
              style={{ width: '50%' }} 
            />
          ) : (
            <img 
              src={crossIcon} 
              alt="Failure Icon" 
              style={{ width: '50%' }} 
            />
          )}
        </div>
        <div className="thank-you-message">
          {isTransactionSuccessful ? (
            <h2 style={{ color: '#4FA0FF' }}>Thank You!</h2>
          ) : (
            <h2 style={{ color: '#FF6B6B' }}>Oops!</h2>
          )}
          <p style={{ color: '#1D3557' }}>Your payment was {txnStatus}.</p>
        </div>
        <div className="redirect-info" style={{ color: '#1D3557' }}>
          <p>Your Transaction ID is: {txnId || "N/A"}</p>
          <p>Transaction Status: {txnStatus}</p>
        </div>
        <button onClick={handleButtonClick} className="thank-you-button" style={buttonStyle}>
          Go to {isLoggedIn ? 'Dashboard' : 'Home'}
        </button>
      </div>
    </div>
  );
};

export default RepayThankyou;